// extracted by mini-css-extract-plugin
module.exports = {"root":"UnlinkedStatusIndicator_root__dCgUq"};